import { Component, computed, inject } from '@angular/core';
import { Routes } from '@angular/router';

import { ChdTabLinkRouterLink, ChdTabNavPresenter } from '@cp-produkte/cruise-hospitality-design';

import { ComponentsModule } from '../components.module';

function toPath(routerLink: ChdTabLinkRouterLink): string {
  return typeof routerLink === 'string' ? routerLink : routerLink.map(String).join('/');
}

/**
 * App-local renderer that draws `ChdTabNav` with the SpaManager's legacy `spa-tabs`.
 * Plug it into the tab-nav slot with
 * `provideChdDxBackend({ tabNav: ChdTabNavSpaRenderer, tabNavPanel: ChdTabNavPanelSpaRenderer })`.
 *
 * Feature gaps vs. the Material renderer: the legacy tabs derive labels from route
 * paths and do not support disabled links, custom labels, or nav-level ARIA options.
 */
@Component({
  selector: 'spa-chd-tab-nav-renderer',
  imports: [ComponentsModule],
  templateUrl: './chd-tab-nav-spa-renderer.component.html',
})
export class ChdTabNavSpaRenderer {
  protected readonly presenter = inject(ChdTabNavPresenter);

  protected readonly routes = computed<Routes>(() =>
    this.presenter.viewState().links.map((link) => ({ path: toPath(link.viewState().routerLink) })),
  );
}

/**
 * App-local passthrough renderer for `ChdTabNavPanel`. Renders the routed content directly,
 * without Angular Material's `mat-tab-nav-panel` wrapper (and its `role="tabpanel"`), so the
 * DX output matches the legacy `spa-tabs` DOM.
 *
 * Pair it with `ChdTabNavSpaRenderer`, which drives navigation via `spa-tabs` and does not
 * consume the panel, so no backend panel registration is needed here.
 */
@Component({
  selector: 'spa-chd-tab-nav-panel-renderer',
  template: '<ng-content />',
})
export class ChdTabNavPanelSpaRenderer {}
